const trackingUtils = require('../modules/utils/tracking.utils');
const postBookingUtils = require('../modules/utils/post_booking.utils');
const postBookingAccommodationHandler = require('../modules/handlers/post_booking_accommodation');
const tripdetailsStorageUtils = require('../modules/utils/tripdetails_storage.utils');
const pbAncillariesCollection = require('od-modules/collections/pb_ancillaries_collection/collection');
const triggerHotelPostBookingCoSearch = require('../modules/utils/post_booking.utils').triggerHotelPostBookingCoSearch;
import navigationEventController from 'od-modules/hsa/navigationEventController';

function loadTrip(queryParams) {
    const data = {
        data: {
            queryParams: {
                email: queryParams.email,
                bookingid: queryParams.bookingId,
            },
        },
        action: 'getTrip',
    };
    Odigeo.trigger('post-booking:loadTrip', data);
}

const onNoBagsAvailable = () => {
    trackingUtils.trackEventWithCategory(
        'my_area_trips_details',
        'baggage_offline_no-available',
        'baggage_offline_no-available_appearances');
    if (Odigeo.History.getPageNameFromFragment() !== 'post_booking') {
        Odigeo.Router.navigate('tripdetails');
    }
};

const onNoSeatsAvailable = () => {
    trackingUtils.trackEventWithCategory(
        'my_area_trips_details',
        'seats_offline_no-available',
        'seats_offline_no-available_appearances');
    if (Odigeo.History.getPageNameFromFragment() !== 'post_booking') {
        Odigeo.Router.navigate('tripdetails');
    }
};

Odigeo.Router.handlers.post_booking = function(params) {
    const parameters = Odigeo.Utils.parseHashParameters(params);
    const hasAccommodationPostBooking = Odigeo._.isEqual(parameters.product, 'accommodation');
    const isHomeCoSearch = Odigeo._.isEqual(parameters.type, 'homeCoSearch');
    const isSeatPostBooking = Odigeo._.isEqual(parameters.product, 'seats');
    var pageName = 'post_booking';
    const BOOKING_INFO = 'bookingInfo';
    var $page = $('#page');
    var widgets = Odigeo.autoloadWidgetsAsync({
        getUsersManager: ['users-manager', 'usersmanager'],
        getPaymentBags: ['post-booking-payment-bags', 'payment'],
        getPostBooking: ['post-booking', 'post_booking'],
        getPostBookingBags: ['post-booking-bags', 'post_booking_bags'],
        getPostBookingSeats: ['post-booking-seats', 'post_booking_seats'],
    });
    var queryParams = postBookingUtils.parsePostBookingParams(params);

    $page.removeClass().addClass(pageName);

    Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.userEventController,
        navigationEventController, {
            viewEvents: {
                'post-booking:loadTrip': 'onLoadTrip',
                'post-booking:noParams': 'onTripLoadError',
                'post-booking-bags:bagsAvailable': 'onBagsAvailable',
                'post-booking-bags:noBagsAvailable': 'onNoBagsAvailable',
                'post-booking-seats:seatsAvailable': 'onSeatsAvailable',
                'post-booking-seats:noSeatsAvailable': 'onNoSeatsAvailable',
                'users-manager:getTripOk': 'onTripLoadOk',
                'users-manager:getTripWithError': 'onTripLoadError',
                'users-manager:getTripError': 'onTripLoadError',
            },
            eventHandlers: {
                onLoadTrip: function(data) {
                    widgets.getUsersManager().execute('submitUserRequest', data);
                    widgets.getPostBookingBags().execute('clearBagSelections');
                    widgets.getPostBookingSeats().execute('clearSeatSelections');
                },
                onTripLoadOk: function(data) {
                    tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, data.bookingDetailDTO);
                    switch (queryParams.product) {
                        case postBookingUtils.availableProducts.none:
                            Odigeo.Router.navigate('tripdetails');
                            break;
                        case postBookingUtils.availableProducts.bags:
                            pbAncillariesCollection.loadTripBags(data.bookingDetailDTO);
                            break;
                        case postBookingUtils.availableProducts.seats:
                            pbAncillariesCollection.loadTripSeats(data.bookingDetailDTO);
                            break;
                        default:
                            Odigeo.Router.navigate('tripdetails');
                            break;
                    }
                },
                onTripLoadError: function(data) {
                    widgets.getPostBooking().execute('bookingNotFound', data);
                },
                onBagsAvailable: function(data) {
                    Odigeo.Session.set('ancillaryInfo', JSON.stringify(data.availableAncillariesOptionsDTO));
                    Odigeo.Router.navigate('tripdetails', {params: 'showFlightInfo=true;product=' + queryParams.product});
                },
                onNoBagsAvailable() {
                    onNoBagsAvailable();
                },
                onSeatsAvailable: function(data) {
                    Odigeo.Session.set('ancillaryInfo', JSON.stringify(data.availableAncillariesOptionsDTO));
                    Odigeo.Router.navigate('tripdetails', {params: 'showFlightInfo=true;product=' + queryParams.product});
                },
                onNoSeatsAvailable() {
                    onNoSeatsAvailable();
                },
            },
        }, hasAccommodationPostBooking && postBookingAccommodationHandler);

    Odigeo.Router.eventController.execute();
    const isAccommodationPostBookingCoSearch = Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBookingCoSearch'));
    if (hasAccommodationPostBooking) {
        if (isHomeCoSearch) {
            Odigeo.trigger('post-booking:launchHomeCoSearch', parameters);
        } else {
            const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
            const touchPointParams = postBookingUtils.getTouchPointParams(isAccommodationPostBookingCoSearch, parameters);
            Odigeo.Session.set('expediaTrackingParameterWapb3', touchPointParams.wapb3);
            postBookingUtils.setBookingTrackingLabelInSessionIfPresent(touchPointParams);
            Odigeo.Session.set('preselectedAccommodation', JSON.stringify({
                providerId: parameters.providerId,
                providerHotelId: parameters.providerHotelId,
                dedupId: parameters.dedupId,
            }));
            postBookingAccommodationHandler.showWaitingPage();
            Odigeo.Session.set('isAccommodationPostBooking', true);
            trackingUtils.trackPage('waiting/1');

            if (isAccommodationPostBookingCoSearch && bookingInfo) {
                triggerHotelPostBookingCoSearch(isAccommodationPostBookingCoSearch, bookingInfo);
            }
        }
    }

    if (!isHomeCoSearch && !isAccommodationPostBookingCoSearch) {
        if (queryParams) {
            loadTrip.call(this, queryParams);
        } else {
            Odigeo.trigger('post-booking:noParams', {});
        }
    }

    if (!hasAccommodationPostBooking && !isSeatPostBooking) {
        // Analytics: virtual page tracking
        trackingUtils.trackPage(pageName, {
            funnel: false,
        });
    }

    pbAncillariesCollection.onTripBagsLoaded({
        success: (data) => widgets.getPostBookingBags().execute('checkAvailableBags', data),
        failure: onNoBagsAvailable,
    });

    pbAncillariesCollection.onTripSeatsLoaded({
        success: (data) => widgets.getPostBookingSeats().execute('checkAvailableSeats', data),
        failure: onNoSeatsAvailable,
    });
};
